<template>
  <el-dialog :title='dialogTitle'
             :visible.sync='dialogVisible'
             width='1100px'
             center
             :close-on-click-modal='false'
             @close='dialogClose'>
    <div class='add'>
      <div class='baseInfo'>
        <div class='baseInfoContent'>
          <div-border label='合同价信息' prop='plan' class='p20'>
            <!--            <el-form :model='form'-->
            <!--                     label-width='110px'-->
            <!--                     label-position='right'-->
            <!--                     :rules='rules'-->
            <!--                     ref='addForm' class='demo-addForm'>-->
            <!--              <div class='yang' v-for='(item, index) in form.formData' :key='index'>-->
            <!--                <el-row>-->
            <!--                  <el-col :span='24'>-->
            <!--                    <el-form-item label='含税金额：' :rules='rules.contactTaxPrice'-->
            <!--                                  :prop='`formData.${index}.contactTaxPrice`'>-->
            <!--                      <el-input-->
            <!--                        v-model='item.contactTaxPrice'-->
            <!--                        :disabled="dialogTitle === '详情'"-->
            <!--                        placeholder='请输入含税金额'-->
            <!--                        oninput="value=value.replace(/[^\d]/g,'')"-->
            <!--                        size='mini' />-->
            <!--                    </el-form-item>-->
            <!--                  </el-col>-->
            <!--                  <el-col :span='24'>-->
            <!--                    <el-form-item label='税率：' :rules='rules.contactTaxRate'-->
            <!--                                  :prop='`formData.${index}.contactTaxRate`'>-->
            <!--                      <el-input-->
            <!--                        v-model='item.contactTaxRate'-->
            <!--                        :disabled="dialogTitle === '详情'"-->
            <!--                        placeholder='请输入税率'-->
            <!--                        @input='priceFormat($event, index)'-->
            <!--                        size='mini'>-->
            <!--                        <template slot='append'>%</template>-->
            <!--                      </el-input>-->
            <!--                    </el-form-item>-->
            <!--                  </el-col>-->
            <!--                </el-row>-->
            <!--              </div>-->
            <!--            </el-form>-->
            <el-table
              :data='tableData'
              style='width: 100%'
              border
              :header-cell-style='headerCellStyle'
              :cell-style='cellStyle'>
              <el-table-column label='批次号' align='center' prop='batchNumber' min-width='120' />
              <el-table-column label='运单号' align='center' prop='waybillNo' min-width='120' />
              <el-table-column label='车架号' align='center' prop='frameNumber' min-width='120' />
              <el-table-column v-if='type === 6' label='作业类型' align='center' min-width='120'>
                <template slot-scope='scope'>{{ scope.row.workType|workTypeFormat }}</template>
              </el-table-column>
              <el-table-column v-else-if='type === 1' label='运输方式' align='center'
                               min-width='120'>
                <template slot-scope='scope'>
                  {{ scope.row.transportationTerms ? '公路' : '水路' }}
                </template>
              </el-table-column>
              <el-table-column label='税率' align='center' min-width='120'>
                <template slot-scope='scope'>
                  <el-input
                    v-model='scope.row.contactTaxRate'
                    placeholder='请输入税率'
                    @input='priceFormat($event, scope.row.id)'
                    size='mini'>
                    <template slot='append'>%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label='含税金额' align='center' min-width='120'>
                <template slot-scope='scope'>
                  <el-input
                    v-model='scope.row.contactTaxPrice'
                    placeholder='请输入含税金额'
                    oninput="value=value.replace(/[^\d]/g,'')"
                    size='mini' />
                </template>
              </el-table-column>
            </el-table>
          </div-border>
          <div class='btnContainer' v-if="dialogTitle !== '详情'">
            <el-button size='medium' class='searchBtn' :loading='loading' @click='submit'>
              确定
            </el-button>
            <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { addContractPrice, getPageListSCFI } from '@/service/getData';

  export default {
    name: 'addContractPrice',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '添加合同价',
        dialogVisible: false,
        basicId: '',
        type: '',
        loading: false,
        headerCellStyle: {
          'color': '#7F7F7F;',
          'font-size': '13px;',
          'height': '48px;',
        },
        cellStyle: {
          'color': '#7F7F7F;',
          'font-size': '13px;',
        },
        tableData: [],
      };
    },
    filters: {
      workTypeFormat(value) {
        switch (value) {
          case 1:
            return '装车';
          case 2:
            return '卸车';
          case 3:
            return '过驳';
          case 4:
            return '转船';
        }
      },
    },
    methods: {
      // 打开弹出框
      openDialog(id, type) {
        this.dialogVisible = true;
        this.basicId = id;
        this.type = type;
        this.getPageListSCFI();
      },
      async getPageListSCFI() {
        const {
          status,
          message,
          data,
        } = await getPageListSCFI({
          id: this.basicId,
          page: 1,
          rows: 99999,
          type: this.type,
        });
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data ? data.records : [];
      },
      // 关闭弹出框
      dialogClose() {
        this.dialogVisible = false;
        this.tableData = [];
        this.$emit('getList');
      },
      // 提交
      async submit() {
        const submitData = [];
        try {
          this.tableData.forEach(res => {
            if (!res.contactTaxRate || !res.contactTaxPrice) {
              throw new Error('请填写税率、含税金额提交！');
            }
            let {
              id,
              batchNumber,
              waybillNo,
              frameNumber,
              workType,
              transportationTerms,
              contactTaxRate,
              contactTaxPrice,
            } = res;
            let transType = this.type === 1 ? transportationTerms : this.type === 6 ? workType : '';
            submitData.push({
              settId: id,
              batchNumber,
              waybillNo,
              frameNumber,
              contactTaxRate,
              contactTaxPrice,
              transType,
              type: this.type,
            });
          });
        } catch (e) {
          return this.$message.warning(e.message);
        }
        const {
          status,
          message,
        } = await addContractPrice({
          accountId: this.basicId,
          priceList: submitData,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.dialogClose();
      },
      // 价格 format
      priceFormat(e, id) {
        let value = e.replace(/[^\d]/g, ''); // 以0开头或者输入非数字，会被替换成空
        if (value.length > 2) value = value.slice(0, 2);
        this.tableData.forEach(res => {
          if (res.id === id) res.contactTaxRate = value;
        });
      },
      // 新增发票
      addInvoice() {
        let flag = false;
        if (this.form.formData && this.form.formData.length > 0) {
          this.form.formData.forEach(res => {
            for (const resKey in res) {
              if (resKey === 'remark') continue;
              if (!res[resKey] || res[resKey] === '') flag = true;
            }
          });
        }
        if (flag) {
          return this.$message.warning('请填写完当前发票信息后新增发票！');
        }
        this.form.formData.push(JSON.parse(JSON.stringify(this.formData)));
      },
    },
  };
</script>

<style lang='scss' scoped>
  ::v-deep .add {

    .el-form-item__label {
      font-weight: 700;
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          margin-top: 10px;

          .el-form-item {

            margin-bottom: 15px;

            .el-form-item__label {
              //width: 150px !important;
              /*color: #060606;*/
            }

            .el-input {
              width: 100%;
            }

            .el-textarea {
              width: 100%;

            }
          }

        }

        .el-upload-list__item {
          width: 100px;
          height: 100px;
        }

        .el-upload--picture-card {
          width: 100px;
          height: 100px;
          line-height: 100px;
        }

        .imgUp {
          display: flex;
          flex-direction: column;

          .imgLength {
            display: flex;
            align-items: center;
            width: 100%;

            span {
              margin-left: auto;
              color: rgb(183, 183, 183);
              font-size: 16px;
            }
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  .el-form-item__content .el-input-group {
    vertical-align: middle;
  }

  .team {

    &Add {
      display: flex;
      align-items: center;
      margin: 20px 0;

      .add {
        width: 20px;
        height: 20px;
        padding-bottom: 3px;
        background-color: #999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin-right: 15px;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }

    &Item {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 10px;

      span {
        margin-left: 5px;
        color: #606266;
        font-weight: 700;
      }

    }
  }
</style>
